import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_BASE_URL } from "../config/api";
import { clearAuthSession } from "../utils/auth";

const config = {
  engineer: { label: "Engineer", key: "engineer", session: "engineerSession", name: "engineerName", destination: "/attendance/engineer", hint: "Engineer ID or email" },
  lg_admin: { label: "LG Admin", key: "lgAdmin", session: "lgAdminSession", name: "lgAdminName", destination: "/attendance/lg-admin", hint: "LG Admin ID or email" },
  admin: { label: "Genmech Admin", key: "admin", session: "adminSession", name: "adminName", destination: "/attendance/admin", hint: "Admin email" }
};

export default function AttendanceLogin() {
  const { role } = useParams();
  const settings = config[role];
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (!settings) return <div className="p-8"><Link to="/attendance">Choose a valid attendance role.</Link></div>;

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/login`, { identifier, password: pin });
      if (response.data.role !== role) throw new Error(`This account does not have ${settings.label} access.`);
      clearAuthSession();
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("role", response.data.role);
      localStorage.setItem(settings.name, response.data.engineerName || response.data.name);
      localStorage.setItem(settings.session, "active");
      if (response.data.engineerId) localStorage.setItem("engineerId", response.data.engineerId);
      navigate(settings.destination, { replace: true });
    } catch (requestError) {
      setError(requestError.response?.data?.message || requestError.message || "Unable to sign in.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4 py-8 text-slate-900">
      <form onSubmit={submit} className="w-full max-w-md rounded-3xl bg-white p-7 shadow-2xl sm:p-9">
        <Link to="/attendance" className="text-sm font-semibold text-sky-700 hover:text-sky-900">← Attendance roles</Link>
        <p className="mt-8 text-xs font-bold uppercase tracking-[0.25em] text-amber-600">LG facility</p>
        <h1 className="mt-2 text-3xl font-black">{settings.label} sign in</h1>
        <p className="mt-2 text-sm leading-6 text-slate-600">Use your assigned ID and secure PIN. PINs are never displayed or stored in plain text.</p>
        <label className="mt-7 block text-sm font-bold">{settings.hint}
          <input value={identifier} onChange={(event) => setIdentifier(event.target.value)} required autoComplete="username" className="mt-2 w-full rounded-xl border border-slate-300 px-4 py-3 outline-none focus:border-sky-600 focus:ring-4 focus:ring-sky-100" />
        </label>
        <label className="mt-4 block text-sm font-bold">PIN
          <input value={pin} onChange={(event) => setPin(event.target.value)} required type="password" autoComplete="current-password" className="mt-2 w-full rounded-xl border border-slate-300 px-4 py-3 outline-none focus:border-sky-600 focus:ring-4 focus:ring-sky-100" />
        </label>
        {error && <p className="mt-4 rounded-xl bg-rose-50 px-3 py-2 text-sm font-medium text-rose-700">{error}</p>}
        <button disabled={loading} className="mt-6 w-full rounded-xl bg-sky-700 px-4 py-3 font-bold text-white transition hover:bg-sky-600 disabled:bg-sky-300">{loading ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
}
